// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"b978b8a7","267":"650f3ce4","413":"1b8ec784","739":"5bfde3b8"}[chunkId] + ".chunk.js";
};